/* unplugin-vue-components disabled */import { render } from "./captchasInfoDIalog.vue?vue&type=template&id=5a59584f&scoped=true"
import script from "./captchasInfoDIalog.vue?vue&type=script&lang=js"
export * from "./captchasInfoDIalog.vue?vue&type=script&lang=js"

import "./captchasInfoDIalog.vue?vue&type=style&index=0&id=5a59584f&lang=stylus&scoped=true"

import exportComponent from "/data/jenkins_home/workspace/JOINMC-H5-HTML-MASTER/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a59584f"]])

export default __exports__